import React from 'react';

export const data = {
  title: "Before You Dive In",
  rows: [
    {
      index: 0,
      title: <b>Are your pay stubs official/legal? </b>,
      content: "Believe it or not, there isn't really a standard or official pay stub. Each province has requirements for what should be  included. In terms of legality, it isn't the pay stub that needs to be official or legal, it’s the contents that need to be truthful and accurate. Misrepresenting your income is serious, so be sure you have everything you need for an accurate pay stub."
    },
    {
      index: 1,
      title: <b>Are your calculations accurate?</b>,
      content: "You bet. We use the official CRA payroll calculator to do our calculations so the deductions will reflect the federal calculations.",
    },
    {
      index: 2,
      title: <b>Are T4s included in your service?</b>,
      content: "They sure are. We provide a T4 report for all customers who have finalized at least one pay stub. This is included in the cost of your pay stubs. You can use the T4 report to fill out a T4 for your employee. We’ll give you instructions on how to do this and a link to download the T4 form from the CRA."
    },
    {
      index: 3,
      title: <b>Do I need to be a registered business? </b>,
      content: "Nope. But you do need to be registered with the CRA to remit taxes, EI and CPP payments."
    },
    {
      index: 4,
      title: <b>What information do I need from my employee? </b>,
      content: "You need their full name, address, and a completed TD1 form (provincial and federal), which can be found here "
    },
    {
      index: 5,
      title: <b>Can I make pay stubs for myself?  </b>,
      content: "Yep, if you are self-employed or if you have responsibility for payroll within the business you work for. Keep in mind that your pay stubs need to accurately represent your income."
    },
    {
      index: 6,
      title: <b>Do I need my own pay stubs as a contractor?</b>,
      content: "Unless you have a specific reason, you don't need pay stubs as a contractor. If you need to represent your income to a lender, you may want to create a pay stub for that reason specifically."
    },
    {
      index: 7,
      title: <b>Do you backdate? </b>,
      content: "We sure do. You can use OneTwoPay to catch up on pay stubs going back as far as three years. We recommend you always start with the first pay stub and then create them in order using the “Next Pay Stub” function on the My Pay Stubs page. Finalize each pay stub as you go to ensure you end up with the correct Year-To-Date (YTD) amounts."
    },
    {
      index: 8,
      title: <b>Can these be sent directly to the employee? </b>,
      content: "No, they can’t. You can email them to yourself and then forward the email to the employee. Or, you can download and then send them that way."
    },
    {
      index: 9,
      title: <b>Do I need to give my employee anything else?</b>,
      content: "You need to give them a T4 at the end of the year and you may need to provide a Record of Employment (ROE) when their employment is terminated."
    },
    {
      index: 10,
      title: <b>What format will I receive the pay stubs in?</b>,
      content: "Pay stubs are provided in PDF format."
    },    
  ]
};